import script from "./signature.vue?vue&type=script&setup=true&lang=js"
export * from "./signature.vue?vue&type=script&setup=true&lang=js"

import "./signature.vue?vue&type=style&index=0&id=42652d20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42652d20"]])

export default __exports__